import gql from 'graphql-tag'

export const ALL_USERS_QUERY = gql`
  query AllUsersQuery {
    allUsers {
      id
      username
      email
    }
  }
`
export const SIGNUP_MUTATION = gql`
  mutation SignupMutation($username: String!, $email: String!, $password: String!) {
    createUser(
      username: $username,
      email: $email,
      password: $password
    ) {
      id
      username
      email
    }
  }
`
export const LOGIN_MUTATION = gql`
  mutation TokenAuth($email: String!, $password: String!) {
    tokenAuth (
      email: $email,
      password: $password
    ) {
      token
    }
  }
`
export const LOGOUT_MUTATION = gql`
  mutation Logout($kill: String!) {
    logout (
      kill: $kill
    ) {
      token
    }
  }
`

export const GET_USER = gql`
  query GetUser($id: Int!) {
    user(id: $id) {
      key
      email
    }
  }
`
